import useApi, { runApWithoutToken } from '../utils/axios-pettitions';
import { get } from '../contexts/slices/config';
import { useAppDispatch } from '../contexts/hooks';
import { Config, InitialConfig, SysIAnalitosValoresRef } from '../types/types.config';
import { newToast } from '../components';
import { FacturacionContratos, FacturacionTarifas } from '../types/types.facturacion';

export const useApiConfiguration = () => {
  const { runApi } = useApi();
  const dispatch = useAppDispatch();

  //Obtener configuración
  const getConfig = async () => {
    const inCnf: InitialConfig = {
      IsAuthenticated: false,
      Loading: false,
      Error: null,
      Data: null,
      HeightPanels: 190,
      IsEditing: false,
      LstAnalitosResulTipoListas: [],
      LstAccionesMonitoreo: [],
      LstUsuarios: [],
      ModalBarcodePrintersVisible: false,
    };
    runApi('Configuration', 'GET').then((res) => {
      if (res.internalCode >= 200) {
        inCnf.Error = res.message;
        inCnf.Data = null;
      } else {
        inCnf.Error = null;
        inCnf.Data = res.data as Config;
      }
      dispatch(get(inCnf));
    });
  };

  //Obtener configuración
  const getUsers = async () => {
    return runApi('Configuration/getLstUsers', 'GET').then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else {
        return res.data;
      }
    });
  };

  const getKeyClient = async () => {
    return runApi('Configuration/getKeyClient', 'GET').then((res) => {
      if (res.internalCode >= 200) {        
        return '';
      } else {
        return res.data;
      }
    });
  };

  const getAccionesMonitoreo = async () => {
    return runApi('Configuration/getLstAccionesMonitoreo', 'GET').then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else {
        return res.data;
      }
    });
  };

  const getServices = async () => {
    return runApi('Configuration/getServices', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  //#region Configuración de Tablas
  const getConfigurableTables = async () => {
    return runApi('Configuration/getConfigurableTables', 'GET').then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getFieldsByTable = async (table: string) => {
    return runApi('Configuration/getFieldsByTable', 'GET', { table }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getDataByTable = async (table: string) => {
    return runApi('Configuration/getDataByTable', 'GET', { table }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const createItemTable = async (table: string, data: any) => {
    return runApi('Configuration/createItemTable', 'POST', { table }, data).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const updateItemTable = async (table: string, conditional: string, data: any) => {
    return runApi('Configuration/updateItemTable', 'POST', { table, conditional }, data).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteItemTable = async (table: string, conditional: string) => {
    return runApi('Configuration/deleteItemTable', 'POST', { table, conditional }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  //#endregion

  //Cambiar configuración

  const getAnalitos = async () => {
    return runApi('Configuration/getAnalitos', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getListasAnalitos = async () => {
    return runApi('Configuration/getListasAnalitos', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getReferencesValues = async (IdAnalito: number) => {
    return runApi('Configuration/getReferencesValues', 'GET', { IdAn: IdAnalito }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

    const getBarcodes = async () => {
    return runApi('Configuration/getBarcodes', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const setConfig = async (dataConfig) => {
    runApi('Configuration/setConfigGeneral', 'POST', null, dataConfig).then((res) => {
      if (res.internalCode >= 200) {        
        return;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return;
      }
    });
  };

  const newAnalitosValRef = async ({ ValRef }) => {
    return runApi('Configuration/newReferencesValues', 'POST', null, ValRef).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setAnalitosValRef = async ({ ValRef, IdValRef }) => {
    return runApi('Configuration/putReferencesValues', 'POST', { IdValRef }, ValRef).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteAnalitosValRef = async ({ IdValRef }) => {
    return runApi('Configuration/deleteReferencesValues', 'POST', { IdValRef }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getValidationRules = async (IdAnalito: number) => {
    return runApi('Configuration/getValidationRules', 'GET', { IdAn: IdAnalito }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newValidationRules = async ({ Rules }) => {
    return runApi('Configuration/newValidationRules', 'POST', null, Rules).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setValidationRules = async ({ Rules, IdRegla }) => {
    return runApi('Configuration/putValidationRules', 'POST', { IdRegla }, Rules).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteValidationRules = async ({ IdRegla, IdAnalito }) => {
    return runApi('Configuration/deleteValidationRules', 'POST', { IdRegla, IdAnalito }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newSampleType = async ({ TipoMuestra }) => {
    return runApi('Configuration/newSampleType', 'POST', null, TipoMuestra).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setSampleType = async ({ TipoMuestra, IdTipoMuestra }) => {
    return runApi('Configuration/putSampleType', 'POST', { IdTipoMuestra }, TipoMuestra).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteSampleType = async ({ IdTipoMuestra }) => {
    return runApi('Configuration/deleteSampleType', 'POST', { IdTipoMuestra }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newAlternateRanks = async ({ Rango }) => {
    return runApi('Configuration/newAlternateRanks', 'POST', null, Rango).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setAlternateRanks = async ({ RangoAlterno, IdRangoAlterno }) => {
    return runApi('Configuration/putAlternateRanks', 'POST', { IdRangoAlterno }, RangoAlterno).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteAlternateRanks = async ({ IdRangoAlterno }) => {
    return runApi('Configuration/deleteAlternateRanks', 'POST', { IdRangoAlterno }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newBarcode = async ({ Barcode }) => {
    return runApi('Configuration/newBarcode', 'POST', null, Barcode).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setBarcode = async ({ Barcode, IdBarcode }) => {
    console.log('setBarcode', Barcode, IdBarcode);
    return runApi('Configuration/putBarcode', 'POST', { IdBarcode }, Barcode).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteBarcode = async ({ IdBarcode }) => {
    return runApi('Configuration/deleteBarcode', 'POST', { IdBarcode }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newUnitMeasurement = async ({ Unidad }) => {
    return runApi('Configuration/newUnitMeasurement', 'POST', null, Unidad).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setUnitMeasurement = async ({ Unidad, IdUnidad }) => {
    return runApi('Configuration/putUnitMeasurement', 'POST', { IdUnidad }, Unidad).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteUnitMeasurement = async ({ IdUnidad }) => {
    return runApi('Configuration/deleteUnitMeasurement', 'POST', { IdUnidad }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getUnitsBase = async () => {
    return runApi('Configuration/getUnitsBase', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newUnitBase = async ({ UnidadBase }) => {
    return runApi('Configuration/newUnitBase', 'POST', null, UnidadBase).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setUnitBase = async ({ Unidad, IdUnidadBase }) => {
    return runApi('Configuration/putUnitBase', 'POST', { IdUnidadBase }, Unidad).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteUnitBase = async ({ IdUnidadBase }) => {
    return runApi('Configuration/deleteUnitBase', 'POST', { IdUnidadBase }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newAnalito = async ({ Analito }) => {
    return runApi('Configuration/newAnalito', 'POST', null, Analito).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setAnalito = async ({ Analito, IdAnalito }) => {
    return runApi('Configuration/putAnalitos', 'POST', { IdAnalito }, Analito).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteAnalito = async ({ IdAnalito }) => {
    return runApi('Configuration/deleteAnalito', 'POST', { IdAnalito }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getEstudios = async () => {
    return runApi('Configuration/getEstudios', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getPerfiles = async () => {
    return runApi('Configuration/getPerfiles', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getPrioridades = async () => {
    return runApi('Configuration/getPrioridades', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getAnalytesByStudy = async (IdEstudio: number) => {
    return runApi('Configuration/getAnalytesByStudy', 'GET', { IdEstudio: IdEstudio }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getStudiesbyProfiles = async (IdPerfil: number) => {
    return runApi('Configuration/getStudiesbyProfiles', 'GET', { IdPerfil: IdPerfil }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newStudy = async ({ Estudio }) => {
    return runApi('Configuration/newStudy', 'POST', null, Estudio).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setStudy = async ({ Estudio, IdEstudio }) => {
    return runApi('Configuration/putStudy', 'POST', { IdEstudio }, Estudio).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteStudy = async ({ IdEstudio }) => {
    return runApi('Configuration/deleteStudy', 'POST', { IdEstudio }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newStudyAnalyte = async ({ RpmAnalito }) => {
    return runApi('Configuration/newRpmStudyAnalyte', 'POST', null, RpmAnalito).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setStudyAnalyte = async ({ RpmAnalito, IdRpm }) => {
    return runApi('Configuration/putRpmStudyAnalyte', 'POST', { IdRpm }, RpmAnalito).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteStudyAnalyte = async ({ IdRpm }) => {
    return runApi('Configuration/deleteRpmStudyAnalyte', 'POST', { IdRpm }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getAnalizadores = async () => {
    return runApi('Configuration/getAnalizadores', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getAnalizadorById = async ({ IdAnalizador }) => {
    return runApi('Configuration/getAnalizadorById', 'GET', { IdAnalizador }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newAnalizador = async ({ Analizador }) => {
    return runApi('Configuration/newAnalizador', 'POST', null, Analizador).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setAnalizador = async ({ Analizador, IdAnalizador }) => {
    return runApi('Configuration/putAnalizador', 'POST', { IdAnalizador }, Analizador).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteAnalizador = async ({ Id }) => {
    return runApi('Configuration/deleteAnalizador', 'POST', { Id }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getAnalytesByAnalyzer = async (id: number) => {
    return runApi('Configuration/getAnalizadorRpmByAnalizador', 'GET', { id: id }, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newAnalyzerAnalyte = async ({ RpmAnalito }) => {
    return runApi('Configuration/newAnalizadorRpm', 'POST', null, RpmAnalito).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setAnalyzerAnalyte = async ({ RpmAnalito, IdRpm }) => {
    return runApi('Configuration/putAnalizadorRpm', 'POST', { IdRpm }, RpmAnalito).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteAnalyzerAnalyte = async ({ Id }) => {
    return runApi('Configuration/deleteAnalizadorRpm', 'POST', { Id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newProfile = async ({ Perfil }) => {
    return runApi('Configuration/newProfile', 'POST', null, Perfil).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setProfile = async ({ Perfil, IdPerfil }) => {
    return runApi('Configuration/putProfile', 'POST', { IdPerfil }, Perfil).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteProfile = async ({ IdPerfil }) => {
    return runApi('Configuration/deleteProfile', 'POST', { IdPerfil }, null).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const newProfileStudy = async ({ RpmEstudio }) => {
    return runApi('Configuration/newRpmProfileStudy', 'POST', null, RpmEstudio).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setProfileStudy = async ({ RpmEstudio, IdRpm }) => {
    return runApi('Configuration/putRpmProfileStudy', 'POST', { IdRpm }, RpmEstudio).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteProfileStudy = async ({ IdRpm }) => {
    return runApi('Configuration/deleteRpmProfileStudy', 'POST', { IdRpm }, null).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getDefiniciones = async () => {
    return runApi('Configuration/getDefinicionesCampos', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getDefinicionesById = async (Id: number) => {
    return runApi('Configuration/getDefinicionCampoById', 'GET', { Id: Id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newDefiniciones = async ({ Definicion }) => {
    return runApi('Configuration/newDefinicionesCampos', 'POST', null, Definicion).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setDefiniciones = async ({ Definicion, IdDefinicion }) => {
    return runApi('Configuration/putDefinicionesCampos', 'POST', { IdDefinicion }, Definicion).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteDefinicion = async ({ Id }) => {
    return runApi('Configuration/deleteDefinicionesCampos', 'POST', { Id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getResultadosTipoListaByAnalito = async (analitoId: number) => {
    return runApi('Configuration/getResultadosTipoLista', 'GET', { analitoId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newResultadoTipoLista = async (data: any) => {
    return runApi('Configuration/newResultadoTipoLista', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', 'Resultado tipo lista creado correctamente', 3);
        return res.internalCode;
      }
      return null;
    });
  };

  const updateResultadoTipoLista = async (id: number, data: any) => {
    return runApi(`Configuration/updateResultadoTipoLista/${id}`, 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 106) {
        newToast('SUCCESS', 'Resultado tipo lista actualizado correctamente', 3);
        return res.internalCode;
      }
      return null;
    });
  };

  const deleteResultadoTipoLista = async (id: number) => {
    return runApi(`Configuration/deleteResultadoTipoLista/${id}`, 'POST', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', 'Resultado tipo lista eliminado correctamente', 3);
        return true;
      }
      return false;
    });
  };

  const setAnalitoTemplate = async ({ IdAnalito, PlantillaJson }: { IdAnalito: number; PlantillaJson: string }) => {
    return runApi('Configuration/updateTemplate', 'POST', {}, { IdAnalito, PlantillaJson }).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const clearCache = async () => {
    return runApi(`Configuration/clearCache`, 'POST', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 109) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  //#region Reportes
  const getReports = async () => {
    return runApi('Configuration/GetAllReports', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const updateReport = async (idReport: number, data: any) => {
    console.log('Updating report:', idReport, data);
    return runApi('Configuration/UpdateReport', 'POST', { idReport }, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', 'Reporte actualizado correctamente', 3);
        return res.internalCode;
      }
      return null;
    });
  };

  const newReport = async (data: any) => {
    return runApi('Configuration/CreateReport', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', 'Reporte creado correctamente', 3);
        return res.internalCode;
      }
      return null;
    });
  };

  //#endregion

  //#region Contratos y tarifas, facturacion
  const getContratos = async () => {
    return runApi('Configuration/getContratos', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const updateTarifaMasive = async (data: any) => {
    return runApi('Configuration/updateTarifaMasive', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const getClientes = async () => {
    return runApi('Configuration/GetClientes', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getPaymentMethods = async () => {
    return runApi('Configuration/GetPaymentMethods', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newContrato = async (data: FacturacionContratos) => {
    return runApi('Configuration/newContrato', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const updateContrato = async (id: number, data: FacturacionContratos) => {
    return runApi('Configuration/updateContrato', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const deleteContrato = async (id: number) => {
    return runApi('Configuration/deleteContrato', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  const GetTarifasByIdContrato = async (idContrato: number) => {
    return runApi('Configuration/GetTarifasByIdContrato', 'GET', { idContrato }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const GetTarifasByIdContratoWithStudies = async (idContrato: number) => {
    return runApi('Configuration/GetTarifasByIdContratoWithStudies', 'GET', { idContrato }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newTarifa = async (data: FacturacionTarifas, idContrato: number) => {
    return runApi('Configuration/newTarifa', 'POST', { idContrato }, data).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const cloneContrato = async (idContrato: number) => {
    return runApi('Configuration/CloneContrato', 'POST', { idContrato }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const newTarifaMasive = async (data: any, idContrato: number) => {
    return runApi('Configuration/newTarifaMasive', 'POST', { idContrato }, data).then((res) => {
      if (res.internalCode >= 200) {
        return { LstSuccess: [], LstError: [] };
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const updateTarifa = async (id: number, data: any) => {
    return runApi('Configuration/updateTarifa', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  const deleteTarifa = async (id: number) => {
    return runApi('Configuration/deleteTarifa', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  //#endregion

  //#region Configuracion de notas plantillas
  const getPlantillasNotas = async () => {
    return runApi('Configuration/getPlantillasNotas', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newPlantillaNota = async (data: any) => {
    return runApi('Configuration/newPlantillaNota', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', 'Plantilla de nota creada correctamente', 3);
        return res.internalCode;
      }
      return null;
    });
  };

  const updatePlantillaNota = async (id: number, data: any) => {
    return runApi('Configuration/putPlantillaNota', 'POST', { IdPlantilla: id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', 'Plantilla de nota actualizada correctamente', 3);
        return res.internalCode;
      }
      return null;
    });
  };

  const deletePlantillaNota = async (id: number) => {
    return runApi('Configuration/deletePlantillaNota', 'POST', { IdPlantilla: id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', 'Plantilla de nota eliminada correctamente', 3);
        return true;
      }
      return false;
    });
  };

  //#endregion

  const updateStudiesMassive = async (estudiosActualizaciones: any[]) => {
    return runApi('Configuration/updateStudiesMassive', 'POST', null, estudiosActualizaciones).then((res) => {
      if (res.internalCode >= 300) {
        return null;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message || 'Estudios actualizados exitosamente', 3);
        return res.data;
      } else if (res.internalCode === 206) {
        // Actualización parcial (algunos errores)
        newToast('WARNING', res.message || 'Actualización completada con algunos errores', 4);
        return res.data;
      } else if (res.internalCode >= 200) {        
        return null;
      }
      return res.data;
    });
  };

  //#Region para RangosExtendidos de Analitos

  const getRangosExtendidos = async (analitoId: number) => {
    return runApi('Configuration/getRangosExtendidos', 'GET', { analitoId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const createRangosExtendidos = async (analitoId: number, rangosExtendidos: any[]) => {
    return runApi('Configuration/createRangosExtendidos', 'POST', { analitoId }, rangosExtendidos).then((res) => {
      if (res.internalCode >= 200) {        
        return null;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', 'Rangos extendidos creados correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  const updateRangosExtendidos = async (rangosExtendidos: any[]) => {
    return runApi('Configuration/updateRangosExtendidos', 'POST', null, rangosExtendidos).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 106) {
        newToast('SUCCESS', 'Rangos extendidos actualizados correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  const deleteRangoExtendido = async (rangoId: number) => {
    return runApi('Configuration/deleteRangoExtendido', 'POST', { rangoId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', 'Rango extendido eliminado correctamente', 3);
        return true;
      }
      return false;
    });
  };

  const deleteAllRangosExtendidos = async (analitoId: number) => {
    return runApi('Configuration/deleteAllRangosExtendidos', 'POST', { analitoId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', 'Todos los rangos extendidos eliminados correctamente', 3);
        return true;
      }
      return false;
    });
  };

  return {
    getKeyClient,
    createItemTable,
    updateItemTable,
    deleteItemTable,
    getDataByTable,
    getConfigurableTables,
    getFieldsByTable,
    getConfig,
    setConfig,
    getAnalitos,
    getServices,
    getListasAnalitos,
    getReferencesValues,
    setAnalitosValRef,
    newAnalitosValRef,
    deleteAnalitosValRef,
    setAnalito,
    newAnalito,
    deleteAnalito,
    getBarcodes,
    getValidationRules,
    newValidationRules,
    setValidationRules,
    deleteValidationRules,
    newSampleType,
    setSampleType,
    deleteSampleType,
    newAlternateRanks,
    setAlternateRanks,
    deleteAlternateRanks,
    newBarcode,
    setBarcode,
    deleteBarcode,
    newUnitMeasurement,
    setUnitMeasurement,
    deleteUnitMeasurement,
    getUnitsBase,
    newUnitBase,
    setUnitBase,
    deleteUnitBase,
    getEstudios,
    getPrioridades,
    getAnalytesByStudy,
    newStudy,
    setStudy,
    deleteStudy,
    newStudyAnalyte,
    setStudyAnalyte,
    deleteStudyAnalyte,
    newProfile,
    setProfile,
    deleteProfile,
    newProfileStudy,
    setProfileStudy,
    deleteProfileStudy,
    getPerfiles,
    getStudiesbyProfiles,
    getUsers,
    getAccionesMonitoreo,
    getAnalizadores,
    getAnalizadorById,
    setAnalizador,
    newAnalizador,
    deleteAnalizador,
    getAnalytesByAnalyzer,
    newAnalyzerAnalyte,
    setAnalyzerAnalyte,
    deleteAnalyzerAnalyte,
    getDefiniciones,
    getDefinicionesById,
    newDefiniciones,
    setDefiniciones,
    deleteDefinicion,
    getResultadosTipoListaByAnalito,
    newResultadoTipoLista,
    updateResultadoTipoLista,
    deleteResultadoTipoLista,
    setAnalitoTemplate,
    getContratos,
    updateTarifaMasive,
    getClientes,
    getPaymentMethods,
    newContrato,
    updateContrato,
    deleteContrato,
    GetTarifasByIdContrato,
    newTarifa,
    updateTarifa,
    deleteTarifa,
    newTarifaMasive,
    cloneContrato,
    GetTarifasByIdContratoWithStudies,
    clearCache,
    getReports,
    updateReport,
    newReport,
    getPlantillasNotas,
    newPlantillaNota,
    updatePlantillaNota,
    deletePlantillaNota,
    getCurrentServerDate,
    updateStudiesMassive,
    getRangosExtendidos,
    createRangosExtendidos,
    updateRangosExtendidos,
    deleteRangoExtendido,
    deleteAllRangosExtendidos,
  };
};

export const getCurrentServerDate: () => Promise<string | null> = async () => {
  try {
    const res = await runApWithoutToken('configuration/getCurrentDate', 'GET');
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    return res.data;
  } catch (err) {
    newToast('ERROR', 'Se ha presentado un error al obtener la fecha del servidor', 5);
    return null;
  }
};
